(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  function pkhScrollToHashTarget(id) {
    let stableCount = 0;
    let attempts = 0;

    const attempt = () => {
      const target = document.getElementById(id);
      if (!target) return;

      target.scrollIntoView({ behavior: 'instant', block: 'start' });

      const top = target.getBoundingClientRect().top;
      attempts++;
      stableCount = Math.abs(top) < 2 ? stableCount + 1 : 0;

      // Doskakujemy ponownie, dopóki cel nie ustabilizuje pozycji przez kilka
      // sprawdzeń z rzędu (limit awaryjny, gdyby coś innego wciąż się animowało).
      if (stableCount < 4 && attempts < 30) {
        setTimeout(attempt, 120);
      }
    };

    attempt();
  }

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => pkhScrollToHashTarget(url.hash.slice(1)),
      { once: true }
    );
  }

  // Linki kotwicowe (np. „Pomóż mi wybrać” w karcie pomocy pod listą)
  // mogą wskazywać na sekcję leżącą POD siatką produktów. Przy włączonym przewijaniu w
  // nieskończoność (22.09, na życzenie Marty) sam skok do kotwicy dociąga kolejne strony
  // produktów, które wsuwają się NAD kotwicą i przesuwają ją niżej — domyślny skok
  // przeglądarki ląduje wtedy w złym miejscu. Dlatego przechwytujemy klik i doskakujemy
  // do celu, aż jego pozycja się ustabilizuje (czyli dociąganie kolejnych stron się skończyło).
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[href*="#"]') : null;
    if (!link) return;

    let linkUrl;
    try {
      linkUrl = new URL(link.href, window.location.href);
    } catch (e) {
      return;
    }

    if (linkUrl.pathname !== window.location.pathname || !linkUrl.hash) return;

    const targetId = linkUrl.hash.slice(1);
    if (!document.getElementById(targetId)) return;

    event.preventDefault();
    history.pushState(null, '', linkUrl.hash);
    pkhScrollToHashTarget(targetId);
  });
  // „Zobacz więcej” zamiast automatycznego doładowywania (23.09, decyzja Marty).
  // Automatyczne doładowanie Horizona jest wyłączone (znacznik [ref=viewMoreNext] ukryty w CSS),
  // a przycisk sam pobiera kolejną stronę tej sekcji (Section Rendering API, z aktywnymi
  // filtrami i sortowaniem z adresu) i dokłada kafelki na koniec listy.
  function pkhMoreUpdate() {
    document.querySelectorAll('[data-pkh-more]').forEach((box) => {
      const list = box.closest('results-list');
      const grid = list && list.querySelector('[ref="grid"]');
      const btn = box.querySelector('[data-pkh-more-btn]');
      const count = box.querySelector('[data-pkh-more-count]');
      if (!grid || !btn) {
        box.hidden = true;
        return;
      }
      const cards = grid.querySelectorAll(':scope > [ref="cards[]"]');
      const last = cards[cards.length - 1];
      const lastPage = Number(grid.dataset.lastPage || 1);
      const current = last ? Number(last.dataset.page || 1) : 1;
      const total = Number(box.dataset.total || 0);
      box.hidden = cards.length === 0;
      if (count) count.textContent = total ? 'Widzisz ' + cards.length + ' z ' + total + ' produktów' : '';
      btn.hidden = current >= lastPage;
    });
  }

  async function pkhLoadMore(list, btn) {
    const grid = list.querySelector('[ref="grid"]');
    if (!grid) return;
    const cards = grid.querySelectorAll(':scope > [ref="cards[]"]');
    const last = cards[cards.length - 1];
    const next = Number((last && last.dataset.page) || 1) + 1;
    if (next > Number(grid.dataset.lastPage || 1)) return;

    const url = new URL(window.location.href);
    url.searchParams.set('page', String(next));
    url.searchParams.set('section_id', list.getAttribute('section-id') || '');
    url.hash = '';

    const response = await fetch(url.toString(), { credentials: 'same-origin' });
    if (!response.ok) throw new Error('HTTP ' + response.status);
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const known = new Set(Array.from(cards, (card) => card.id));
    doc.querySelectorAll('[ref="grid"] > [ref="cards[]"]').forEach((item) => {
      if (!known.has(item.id)) grid.append(document.adoptNode(item));
    });
  }

  document.addEventListener('click', async (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-pkh-more-btn]') : null;
    if (!btn || btn.disabled) return;
    const list = btn.closest('results-list');
    if (!list) return;

    const label = btn.dataset.label || btn.textContent;
    btn.dataset.label = label;
    btn.disabled = true;
    btn.textContent = 'Wczytuję…';
    try {
      await pkhLoadMore(list, btn);
    } catch (e) {
      console.warn('Zobacz więcej: nie udało się wczytać kolejnej strony', e);
    }
    btn.disabled = false;
    btn.textContent = label;
    pkhMoreUpdate();
  });

  function pkhMoreInit() {
    pkhMoreUpdate();
    const root = document.querySelector('collection-component');
    if (root) {
      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          pkhMoreUpdate();
        });
      }).observe(root, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pkhMoreInit, { once: true });
  } else {
    pkhMoreInit();
  }

  } catch(e) { console.error(e); }
})();
})();
